<section class="wrapper">

    <app-sidebar></app-sidebar>
</section>
<section id="content">
    <app-header></app-header>

    <app-breadcrumbs></app-breadcrumbs>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <!-- <div [style.height.px]="height" style="width: 100%; overflow-y: auto;">
        <router-outlet></router-outlet>
        <app-footer></app-footer>
    </div> -->



</section>